// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"0cec1eed","131":"aa91fd60","227":"c3e078ad","320":"5d8673de","624":"396b3f64","732":"23c7856f","761":"341bc4bb","934":"3060d9dd","977":"eac6fe8e"}[chunkId] + ".chunk.js";
};